import React, { useRef, useState } from "react";
import { FlowchartHeader } from "./FlowchartHeader";
import { FlowchartActions } from "./FlowchartActions";
import { FlowchartCanvas } from "./FlowchartCanvas";
import { FlowchartModal } from "./FlowchartModal";
import { useFlowchartExport } from "./hooks/useFlowchartExport";
import type { FlowchartData } from "@/lib/chat/parseFlowchartBlock";

interface FlowchartProps {
  data: FlowchartData;
}

export const Flowchart: React.FC<FlowchartProps> = ({ data }) => {
  const containerRef = useRef<HTMLDivElement>(null);
  const [expanded, setExpanded] = useState(false);
  const { exportPNG } = useFlowchartExport(containerRef, data.title);

  return (
    <>
      <div
        ref={containerRef}
        className="relative w-full overflow-hidden rounded-lg border border-border bg-card shadow-sm"
      >
        <FlowchartHeader title={data.title} />
        <FlowchartCanvas data={data} />
        <FlowchartActions
          onDownload={exportPNG}
          onExpand={() => setExpanded(true)}
        />
      </div>

      <FlowchartModal
        open={expanded}
        onClose={() => setExpanded(false)}
        data={data}
      />
    </>
  );
};
